import { render } from "./PerformanceAdvancedView.vue?vue&type=template&id=9a3cdac6&scoped=true"
import script from "./PerformanceAdvancedView.vue?vue&type=script&lang=js"
export * from "./PerformanceAdvancedView.vue?vue&type=script&lang=js"

import "./PerformanceAdvancedView.vue?vue&type=style&index=0&id=9a3cdac6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3cdac6"]])

export default __exports__